module.exports = __webpack_public_path__ + "img/question3-answer-with-ref.0e95d788.jpg";